import React, { useEffect, useState } from 'react'
import Accordion from '../../../../components/Accordion/Accordion'
import Buttons from '../../../../components/ui/button/Buttons'
import { useParams } from 'react-router-dom';
import { decryptAESID } from '../../../../utils/Encryption';
import { useLazyGetSGBCCorporateMemberFinacationInformationByIdQuery } from '../../../../app/services/corporateMembership/corporateMemberApi';
import { useLazyGetPDFQuery } from '../../../../app/services/common/commonApi';
import { saveAs } from 'file-saver';
import formatDate from '../../../../lib/formatDate';
import ToastService from '../../../../services/toastService/ToastService';

const FinancialRecords = () => {
  const { id } = useParams();
  const editID = id ? decryptAESID(id, false) : 0
  const [getSGBCCorporateMemberFinacationInformationById, { data: sGBCCorporateMemberFinacationInformationData, isLoading: corporateMemberDetailsLoading, isFetching: corporateMemberDetailsFetching, isError: corporateMemberDetailsIsError, error: corporateMemberDetailsError, }] = useLazyGetSGBCCorporateMemberFinacationInformationByIdQuery();
  const [getPDF, { isSuccess: isSuccessGetPDF, isLoading: isLoadingGetPDF, data: getPDFData, },] = useLazyGetPDFQuery();
  useEffect(() => {
    if (id) {
      getSGBCCorporateMemberFinacationInformationById(editID)
    }
  }, [id]);

  const onInvoiceReceiptCertificateFileDownload = async (flag, name, field) => {
    const fileName = name?.split("\\").pop();
    let request = {
      type: flag,
      fileName: name,
    };
    const response = await getPDF(request);

    if (response?.data) {
      if (field === "invoice") {
        saveAs(response?.data?.fileData, fileName);
      } else if (field === "certificate") {
        saveAs(response?.data?.fileData, fileName);
      }
    } else {
      ToastService.error("Something Went Wrong");
    }
  };

  return (
    <Accordion title="Financial Records" button={false}>
      <>
        {sGBCCorporateMemberFinacationInformationData?.map((item, key) => {
          return (<>
            <div className="payment-card">
              <div className="payment-status">
                {item?.paymentStatus === "Success" ? "Paid" : item?.paymentStatus === "Pending" ? "Pending Payment" : item?.paymentStatus}
              </div>

              <div className="payment-content">
                <div className='payment-card-body'>
                  <p className='invoice-field'>
                    <span className='key-invoice'><strong>Payment Date:</strong></span>{" "}
                    <span>{item?.receiptDate == null ? "-" : formatDate(item?.receiptDate, "DD/MM/YYYY")}</span>
                  </p>
                  <p className='invoice-field'>
                    <span className='key-invoice'><strong>Invoice Amount:</strong></span>
                    {/* {item?.receiptDate == null ? "-" : `$${(item?.totalAmount ?? 0).toFixed(2)}`} */}
                    {item?.receiptDate == null ? "-" : `$${(item?.totalAmount ?? 0).toLocaleString("en-SG", { minimumFractionDigits: 2, maximumFractionDigits: 2, })}`}
                  </p>
                  <p className='invoice-field'>
                    <span className='key-invoice'><strong>Invoice No:</strong></span> {item?.receiptDate == null ? "-" : (item?.invoiceNumber)}
                  </p>

                  <p className='invoice-field'>
                    <span className='key-invoice'><strong>Amount Received:</strong></span>{" "}
                    {/* {item?.paymentStatus === "Success" ? `$${(item?.totalAmount ?? 0).toFixed(2)}` : "-"} */}
                    <span className="kv-value">
                      {item?.paymentStatus === "Success" ? `$${(item?.totalAmount ?? 0).toLocaleString("en-SG", { minimumFractionDigits: 2, maximumFractionDigits: 2, })}` : "-"}
                    </span>
                  </p>
                  <p className='invoice-field'>
                    <span className='key-invoice'><strong>Payment Status:</strong></span> {item?.receiptDate == null && item?.paymentStatus === "Success" ? "-" : (item?.paymentStatus)}
                  </p>
                </div>
                <div className="payment-left">
                  <div className="row description">
                    {/* <p>
                        <strong>Description:</strong>
                      </p> */}
                    {/* <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                        do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                        Ut enim ad minim veniam, quis nostrud exercitation ullamco
                        laboris nisi ut aliquip ex ea commodo consequat. Duis aute
                        irure dolor in reprehenderit in voluptate velit esse cillum
                        dolore eu fugiat nulla pariatur. Excepteur sint occaecat
                        cupidatat non proident, sunt in culpa qui officia deserunt
                        mollit anim id est laborum.
                      </p> */}
                  </div>
                </div>

                <div className="payment-right">
                  <Buttons
                    buttonText="View Certificate"
                    buttonTypeClassName="btn orange"
                    onClick={() => onInvoiceReceiptCertificateFileDownload("FullFilePath", item?.certificatePath, "certificate")}
                  />
                  <Buttons
                    buttonText="View Invoice"
                    buttonTypeClassName="btn green"
                    onClick={() => onInvoiceReceiptCertificateFileDownload("FullFilePath", item?.invoicePath, "invoice")}
                  />
                  {/* <Buttons
                      buttonText="View Receipt"
                      buttonTypeClassName="btn dark-green"
                      // onClick={handleDownload}
                    /> */}
                </div>
              </div>
            </div>
            <hr></hr>
          </>);
        })}
      </>
    </Accordion>
  );
};

export default FinancialRecords
